import React, { useEffect, useState } from 'react';
import { getTheme, IStyle, ITheme, mergeStyleSets, PanelType } from '@fluentui/react';
import { BwjSidePanel } from '../../../../framework/components/bwj-side-panel';
import { DoorSortMode } from '../../entities/door-sort-options';
import { ProjectService } from '../../../services/project';
import { StormShoppingPrefsSelector } from '../st-door-pref-select';
import { useProjectConfiguration } from '../../../../services/customer-account';
import { fireShowColorPrefsPanel } from '../../../events';
import { BwjEventArgs } from '../../../../framework/entities/bwj-event';

interface IStormDoorShoppingPrefsPanelProps {
  invokeShowMobilePanel: BwjEventArgs<null> | undefined;
  showDesktopPanel: boolean;
  pageAllowDesktopPanel: boolean;
}

const getStyleClasses = (theme: ITheme) => {
  const desktopMenu: IStyle = {
    boxSizing: 'border-box',
    display: 'none',
    width: 280,
    height: '100%',
    backgroundColor: theme.palette.neutralLighter,
    paddingTop: '2rem',

    '@media(min-width: 651px)': {
      display: 'block',
    },
  };

  return mergeStyleSets({
    desktopMenu,
  });
};

const subscriberId = 'Panel.StormDoorShoppingPrefs';

export const StormDoorShoppingPrefsPanel: React.FunctionComponent<IStormDoorShoppingPrefsPanelProps> = (props) => {
  const theme = getTheme();
  const { invokeShowMobilePanel } = props;
  const [showMobilePanel, setShowMobilePanel] = useState(false);
  const [sortMode, setSortMode] = useState<DoorSortMode>(ProjectService.getDoorSortingPreference());
  const projectConfig = useProjectConfiguration(subscriberId);
  const styles = getStyleClasses(theme);

  useEffect(() => {
    if(!!invokeShowMobilePanel && invokeShowMobilePanel.accessible()) {
      invokeShowMobilePanel.getArgs();
      setShowMobilePanel(true);
    } else {
      setShowMobilePanel(false);
    }
  }, [invokeShowMobilePanel]);

  const onUpdateSortMode = (sm: DoorSortMode) => {
    ProjectService.setDoorSortingPreference(sm);
    setSortMode(sm);
    setShowMobilePanel(false);
  }

  const onColorPrefChangeRequested = () => {
    fireShowColorPrefsPanel(projectConfig);
    setShowMobilePanel(false);
  }

  return (
    <>
      <BwjSidePanel
        showPanel={showMobilePanel}
        title={'My Preferences'}
        panelType={PanelType.smallFixedNear}
        onDismiss={() => setShowMobilePanel(false)}
        closeButtonAriaLabel={'Close main menu'}
      >
        <StormShoppingPrefsSelector
          selectedColors={projectConfig.stormDoorColorPreferences}
          sortMode={sortMode}
          onSortModeChanged={onUpdateSortMode}
          onColorPrefChangeRequested={onColorPrefChangeRequested}
        />
      </BwjSidePanel>
      {props.showDesktopPanel && props.pageAllowDesktopPanel &&
      <div className={styles.desktopMenu}>
        <StormShoppingPrefsSelector
          selectedColors={projectConfig.stormDoorColorPreferences}
          sortMode={sortMode}
          onSortModeChanged={onUpdateSortMode}
          onColorPrefChangeRequested={onColorPrefChangeRequested}
        />
      </div>}
    </>
  );
};